// 礼物定义目录（EP-006-S1）—— 10 件 MVP 礼物（Config B，含蜂蜜罐；明信片 v2 起不再作礼物，
// 改为信件（mailbox），见 production/CHANGELOG.md §10）。
// 数字只在 src/domain/drop/dropConfig.ts 出现；本文件只描述「是什么」，不描述「掉率」。
// 名称 / 档位 / desc 逐字取自 GDD 03 §④-4.2（文案纪律：客观白描、不评价价值、无感叹号）。
import type { Rarity } from '../../save/types';

export interface GiftDef {
  id: string; // 与掉落/背包外键一致（无 gift_ 前缀；gift_ 前缀是图像 AssetId 命名空间）
  name: string; // 中文展示名
  desc: string; // 空间点开看的一句话描述（10–15 字）
  rarity: Rarity; // N / U / R / L
  enabled: boolean; // true = 进入 MVP 池；false = 预留母题（不进分母、不进池）
}

// 10 件 MVP 礼物（GDD 01 §5.3 Config B）。分母 = enabled 母题数 = 10（GDD 03 §⑤；明信片 v2 起移除）。
export const GIFTS: GiftDef[] = [
  { id: 'twig', name: '小树枝', desc: '一段结实的枯枝，断口很整齐。', rarity: 'N', enabled: true },
  { id: 'pebble', name: '河卵石', desc: '被水磨了很多年的圆石。', rarity: 'N', enabled: true },
  { id: 'maple_leaf', name: '枫叶', desc: '压平的枫叶，叶脉还清楚。', rarity: 'N', enabled: true },
  { id: 'mushroom', name: '小蘑菇', desc: '伞盖很小，闻着有泥土味。', rarity: 'N', enabled: true },
  { id: 'marshmallow', name: '棉花糖', desc: '集市上买的，有点受潮了。', rarity: 'N', enabled: true },
  { id: 'shell', name: '贝壳', desc: '贴在耳边能听见风声。', rarity: 'U', enabled: true },
  { id: 'pinecone', name: '松果', desc: '鳞片张开了，掉出两颗松子。', rarity: 'U', enabled: true },
  { id: 'honey_jar', name: '蜂蜜罐', desc: '粗陶小罐，晃一晃蜜会流动。', rarity: 'R', enabled: true },
  { id: 'wind_chime', name: '风铃', desc: '陶制的，声音闷闷的。', rarity: 'R', enabled: true },
  { id: 'star_bottle', name: '星星瓶', desc: '瓶子里装着会发光的沙。', rarity: 'L', enabled: true },
];

// 图鉴分母（GDD 03 §⑤）：enabled 母题数，绝不缓存常量，派生自目录。
// v2 移除明信片后自动从 11 → 10，无需手改。
export const CATALOG_DENOMINATOR = GIFTS.filter((g) => g.enabled).length;

// 便于按 id 查定义（背包/揭晓渲染用，不复制名称/档位进存档）。
export const GIFT_BY_ID: Record<string, GiftDef> = Object.fromEntries(
  GIFTS.map((g) => [g.id, g]),
);
